module.exports = {"440512001":"达濠街道","440512002":"马窖街道","440512003":"礐石街道","440512004":"广澳街道","440512005":"滨海街道","440512006":"河浦街道","440512007":"玉新街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440512.json
// module id = 1806
// module chunks = 0